import { ApiResponseObject } from "../../../types";
import { axios } from "../../../utils/axios";
import {
  IDrustvoAktivniObjektiProps,
  Trademark,
  TrademarkListPayload,
} from "./records.types";

const createDrustvoAktivniObjekti = (): Promise<
  ApiResponseObject<IDrustvoAktivniObjektiProps[]>
> => {
  return axios.post("/drustvoAktivniObjekti");
};

const getAllTrademarks = (
  payload: TrademarkListPayload
): Promise<ApiResponseObject<Trademark[]>> => {
  return axios.post("/robneMarkePretraga", payload);
};

export const recordsRepo = {
  createDrustvoAktivniObjekti,
  getAllTrademarks,
};
